import { useRootStore } from "store";

export const filterDuplicateFiles = (
  addFiles: File[],
  existingAttachments: File[]
) => {
  const duplicateFileNames: string[] = [];

  const newFilesToAdd = addFiles.filter((newFile) => {
    const isDuplicate = existingAttachments.some(
      (existing) =>
        existing.name === newFile.name &&
        existing.size === newFile.size &&
        existing.lastModified === newFile.lastModified &&
        existing.type === newFile.type
    );
    if (isDuplicate) {
      duplicateFileNames.push(newFile.name);
    }
    return !isDuplicate;
  });

  if (duplicateFileNames.length > 0) {
    const addNotification =
      useRootStore.getInitialState().toastNotifications.addNotification;
    addNotification(
      "warning",
      `Följande filer är redan uppladdade: ${duplicateFileNames.join(", ")}`
    );
  }

  return newFilesToAdd;
};
